import * as yup from 'yup';

export const newDashboardElementFormValidationSchema = (t: any) => yup.object({
  id: yup
    .number()
    .required(),
  element: yup
    .string()
    .required(t('dashboardElementIsRequired')),
});
